import './admin-mobile-menu.scss';

import React, { useEffect } from 'react';
import { useLocation } from 'react-router';

import MobileBurgerMenuIcon from '@/media/icons/mobile-burger-menu.svg?react';
import { ROUTES } from '@/shared/routes';
import { LocalizedNavLink } from '@/shared/ui';
import { useAppDispatch, useAppSelector } from '@/store';
import {
  setAdminMobileMenuItem,
  setSidebarExpanded
} from '@/store/user-info.slice';

import { adminSideBarItems } from '../../constants/navbar';

const AdminMobileMenu: React.FC = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const { adminMobileMenuItem } = useAppSelector((state) => state.userInfo);

  const selectedMenuItem = adminSideBarItems.find(
    (item) => item.key === adminMobileMenuItem
  );

  useEffect(() => {
    const excludedKeys: string[] = [
      'admin/users',
      'admin/clients',
      ROUTES.leasingScoring
    ];

    const filteredItems = adminSideBarItems.filter(
      (elem) => !excludedKeys.includes(elem.key)
    );
    const foundItem = filteredItems.find((item) =>
      location.pathname.includes(item.key)
    );

    const newMenuItemKey =
      foundItem?.key || adminMobileMenuItem || filteredItems[0]?.key;

    if (newMenuItemKey) {
      dispatch(setAdminMobileMenuItem(newMenuItemKey));
    }
  }, [location.pathname, adminSideBarItems]);

  return (
    <div className="admin-mobile-menu">
      {adminSideBarItems
        .filter((item) => ['admin/users', 'admin/clients'].includes(item.key))
        .map((item) => (
          <LocalizedNavLink
            key={item.key}
            to={item.key.replace(/\/(\/)/, '$1')}
            className={({ isActive }) =>
              `admin-mobile-menu__link ${isActive ? 'admin-mobile-menu__link--active' : ''}`
            }
          >
            {item.icon}
            <span>{item.label}</span>
          </LocalizedNavLink>
        ))}
      {selectedMenuItem && (
        <LocalizedNavLink
          to={selectedMenuItem.key}
          className={({ isActive }) =>
            `admin-mobile-menu__link ${isActive ? 'admin-mobile-menu__link--active' : ''}`
          }
        >
          {selectedMenuItem.icon}
          <span>{selectedMenuItem.label}</span>
        </LocalizedNavLink>
      )}
      <button
        className="admin-mobile-menu__button-icon"
        onClick={() => dispatch(setSidebarExpanded(true))}
      >
        <MobileBurgerMenuIcon />
      </button>
    </div>
  );
};

export default AdminMobileMenu;
